import React from 'react';

export default class IntercomWidget extends React.Component {

	constructor(props) {
		super(props);

		this.settings = {};
		this.supportConfig = props.tenantConfig.support;

		if (props.session && props.session.user) {
			let user = props.session.user;

			this.settings.user_id = user.id;
			this.settings.email = user.email;
			this.settings.name = 'Guest';

			if (user.firstName) {
				let name = user.firstName.trim();
				if (user.lastName) {
					name = name + ' ' + user.lastName.trim();
				}

				this.settings.name = name;
			}
		}
	}

	// This component has no state!
	shouldComponentUpdate() {
		return false;
	}

	componentDidMount() {
		let self = this;

		if (!(this.supportConfig && this.supportConfig.intercom && this.supportConfig.intercom.enabled)) {
			return;
		}

		if (window.addEventListener) {
			window.addEventListener('load', function () {
				self.enableIntercomIfRequired();
			}, false);
		}
		else if (window.attachEvent) {
			window.attachEvent('onload', function () {
				self.enableIntercomIfRequired();
			});
		}
	}

	componentWillUnmount() {
		if (window.Intercom) {
			window.Intercom('shutdown');
		}
	}

	enableIntercomIfRequired() {
		// Skip mobile, good enough detection
		if (window.devicePixelRatio && window.devicePixelRatio > 1 && window.screen && window.screen.width < 576) {
			return false;
		}

		if (window.Intercom) {
			return;
		}

		this.settings.app_id = this.supportConfig.intercom.appId;
		window.intercomSettings = this.settings;

		setTimeout(function () {
			let script = document.createElement('script');
			script.async = true;
			script.src = 'https://widget.intercom.io/widget/' + window.intercomSettings.app_id;

			document.body.appendChild(script);
		}, 48);
	}

	render() {
		return null;
	}
}
